import React from 'react';
import { Paper, Typography, Button } from '@mui/material';

const CharacterPromptBanner = ({ onOpenCreateCharacterModal }) => {
  return (
    <Paper 
      elevation={3} 
      sx={{ 
        p: 2, 
        backgroundColor: '#444444', // Dark theme for banner
        border: '1px solid #d98d2a',
        color: '#F5F5F5',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 0, // Optional: Remove border radius if you want it to be flush
        // Consider adding width: '100%' if it should span the full width like a navbar section
      }}
    >
      <Typography variant="h6" sx={{ fontFamily: '"Georgia", serif' }}>
        No character found for your account.
      </Typography>
      <Button 
        variant="contained" 
        onClick={onOpenCreateCharacterModal}
        sx={{
          fontFamily: '"Georgia", serif',
          backgroundColor: '#d98d2a', 
          color: '#1c1c1c',
          '&:hover': { backgroundColor: '#c87d26' }
        }}
      >
        Create Character
      </Button>
    </Paper>
  );
};

export default CharacterPromptBanner;
